export default "__VITE_ASSET__llxeaDXv__"